<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "large" color = "#fff" type = "ball-scale-multiple" [fullScreen] = "true"></ngx-spinner>
<div class="page-container">
  <div class="container-fluid">
    <div class="row flex-column flex-md-row">
      <app-sidebar-header class="side-common-style side-first-style d-flex align-items-center position-relative z-index-2"></app-sidebar-header>
      <router-outlet class="d-none"></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
